// extracted by mini-css-extract-plugin
export default {"container":"_5NuqqZiC4sh4COtfdOICQg","column":"_5asisKvrV0uwEXg2WCVZFl","header":"_70NceNb8lu210nJDmozZfR"};